import React from 'react';
import ReactDOM from 'react-dom';
import Screen from '../ui/Screen';
const screenRoot = document.getElementById('screen-root') || document.body;
export const createEmpty = (options) => {


    const {
        closable = false,
        is_modal = false,
        component,
        title = "",
        offset = [0, 0],
        callback = () => { },
        signal = {}
    } = options

    const div = document.createElement('div');


    screenRoot.appendChild(div);

    const closeScreen = (e) => {
        callback(e);
        if (screenRoot.contains(div)) {
            ReactDOM.unmountComponentAtNode(div);
            screenRoot.removeChild(div);

        }
    };
    ReactDOM.render(<div style={{"justifyContent" : "left", "alignItems" : "start"}} className='ui-screen'> {React.cloneElement(component, { callback: closeScreen })}</div>, div);
};
